require("core-js/modules/es6.map");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.date.now");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.assign");

!function (t, e) {
  "object" == typeof exports && "undefined" != typeof module ? e(exports) : "function" == typeof define && define.amd ? define(["exports"], e) : e((t = t || self)["@tinacms/alerts"] = {});
}(this, function (t) {
  "use strict";

  var _e = function e() {
    return (_e = Object.assign || function (t) {
      for (var e, r = 1, n = arguments.length; r < n; r++) {
        for (var i in e = arguments[r]) {
          Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
        }
      }

      return t;
    }).apply(this, arguments);
  },
      r = (n.prototype.setMap = function (t) {
    this.map = _e(_e({}, this.map), t);
  }, n.prototype.add = function (t, e, r) {
    var n = this;
    void 0 === r && (r = 3e3);
    var i = {
      level: t,
      message: e,
      timeout: r,
      id: e + "|" + Date.now()
    };

    function s() {
      clearTimeout(o), n.dismiss(i);
    }

    this.alerts.set(i.id, i), this.events.dispatch({
      type: "alerts:add",
      alert: i
    });
    var o = null;
    return o = setTimeout(s, i.timeout), s;
  }, n.prototype.dismiss = function (t) {
    this.alerts["delete"](t.id), this.events.dispatch({
      type: "alerts:remove",
      alert: t
    });
  }, n.prototype.subscribe = function (t) {
    var e = this.events.subscribe("alerts", t);
    return function () {
      return e();
    };
  }, Object.defineProperty(n.prototype, "all", {
    get: function get() {
      return Array.from(this.alerts.values());
    },
    enumerable: !0,
    configurable: !0
  }), n.prototype.info = function (t, e) {
    return this.add("info", t, e);
  }, n.prototype.success = function (t, e) {
    return this.add("success", t, e);
  }, n.prototype.warn = function (t, e) {
    return this.add("warn", t, e);
  }, n.prototype.error = function (t, e) {
    return this.add("error", t, e);
  }, n);

  function n(t, e) {
    var o = this;
    void 0 === e && (e = {}), this.events = t, this.map = e, this.alerts = new Map(), this.mapEventToAlert = function (t) {
      var e = o.map[t.type];

      if (e) {
        var r = ("function" == typeof e ? e : function () {
          return e;
        })(t),
            n = r.level,
            i = r.message,
            s = r.timeout;
        o.add(n, i, s);
      }
    }, this.events.subscribe("*", this.mapEventToAlert);
  }

  t.Alerts = r, Object.defineProperty(t, "__esModule", {
    value: !0
  });
});